module.exports = __webpack_public_path__ + "static/scale-model-of-luther-burbank-home-&-gardens-in-santa-rosa-california-7ffdeceb218c8e3e221da09a7ae4ab43.png";